/* =================== SLIDE HOME =================== */
$(function () {
  const slideItems = $(".slide-home > a").length;
  const slideDots = slideItems > 1;
  $(".slide-home")
    .on("init", function () {
      $(".slide-content").show();
    })
    .slick({
      // lazyLoad: "ondemand",
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      autoplay: true,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            arrows: false,
          },
        },
        {
          breakpoint: 760,
          settings: {
            arrows: false,
            dots: slideDots,
          },
        },
      ],
    })
    .on("beforeChange", function () {
      $(".slide-content").hide();
    })
    .on("afterChange", function () {
      $(".slide-content").show();
    });
});
